import { useLocalisation } from '@3plearning/lingui-cdn';

export const useTranslations = () => {
    const { i18n } = useLocalisation();

    return {
        tooManyCertificates: i18n.t`Certificates - tooManyCertificates`
    };
};



// WEBPACK FOOTER //
// ./components/certificates/hooks/use-translations.js